
define('text!core/directives/cmsSpot.html',[],function () { return '<div>\n    <section data-ng-show="cmsServiceUnavailable" data-ng-include="getTemplate(\'core/partials/serviceUnavailable.html\')"></section>\n    <div data-ng-bind-html="cmsData" data-ng-show="cmsData && !cmsServiceUnavailable"></div>\n</div>';});

